// apps/client/src/ui/screens/fishLog.tsx (M1-T15) — every species: caught ones with icon, name, count and biggest; the rest as a dimmed
// silhouette. Listed in the Menu.
import { itemsOfKind, type FishEntry } from '@whiskerton/content';
import type { FishLogEntry } from '@whiskerton/shared';
import { useGame } from '../../state/store';
import { itemName, useT } from '../i18n';
import { useIcon } from '../items/useIcon';
import { Panel } from '../kit';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { fishLog: undefined } }

function Cell({ fish, log }: { fish: FishEntry; log: FishLogEntry | undefined }) {
  const t = useT();
  const icon = useIcon(fish.id);
  return (
    <div className="fishlog-cell" data-caught={log ? 'yes' : 'no'} style={{ display: 'grid', justifyItems: 'center', gap: 2, textAlign: 'center', padding: 6, borderRadius: 14, background: 'var(--cream-200, #F6EEDC)' }}>
      <img src={icon} alt="" style={{ width: 56, height: 56, filter: log ? undefined : 'brightness(0) opacity(0.28)' }} />
      <strong>{log ? itemName(fish.name) : t('fishing.logUnknown')}</strong>
      {log && <small>{t('fishing.logCount', { count: log.count })}</small>}
      {log && <small>{t('fishing.logBiggest', { size: log.biggest })}</small>}
    </div>
  );
}

function FishLog() {
  const t = useT();
  const log = useGame((s) => s.you?.fishLog);
  const all = itemsOfKind('fish');
  const byId = new Map((log ?? []).map((e) => [e.catalogId, e]));
  return (
    <Panel title={t('fishing.logTitle')} className="fishlog-panel">
      <p style={{ marginTop: 0 }}>{t('fishing.logProgress', { n: all.filter((f) => byId.has(f.id)).length, total: all.length })}</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 8, width: '78cqw', maxWidth: '100%', maxHeight: '62cqh', overflowY: 'auto' }}>
        {all.map((f) => <Cell key={f.id} fish={f} log={byId.get(f.id)} />)}
      </div>
    </Panel>
  );
}
export const screen: ScreenDef<'fishLog'> = { id: 'fishLog', layer: 'panel', component: () => <FishLog />, menu: { label: 'fishing.logTitle', order: 30 } };
